import { ReactNode } from 'react';
import styled from 'styled-components';

import { LabelS } from '@sorare/core/src/atoms/typography';

const Wrapper = styled.div`
  &:not(:has(.FilterWidget.visible)) {
    display: none;
  }
`;

const Title = styled(LabelS)`
  margin-bottom: var(--half-unit);
`;

const Box = styled.div`
  overflow: hidden;
  border-radius: var(--unit);
  box-shadow: inset 0px 0px 0px 1px var(--c-nd-150);
`;

type Props = {
  title?: ReactNode;
  children: ReactNode;
};

export const FiltersGroup = ({ title, children }: Props) => {
  return (
    <Wrapper>
      {title && (
        <Title uppercase bold color="var(--c-nd-600)">
          {title}
        </Title>
      )}
      <Box>{children}</Box>
    </Wrapper>
  );
};
